var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4731 9.57273L12.9091 12.0431C13.2321 12.3707 13.2321 12.9166 12.9226 13.2305C12.7611 13.3943 12.5457 13.4762 12.3304 13.4762C12.1151 13.4762 11.8997 13.3943 11.7382 13.2305L9.30215 10.7601C8.37349 11.4562 7.21602 11.8793 5.9778 11.8793C2.89572 11.8793 0.378906 9.3407 0.378906 6.20156C0.378906 3.07606 2.88226 0.523804 5.9778 0.523804C9.05989 0.523804 11.5767 3.06242 11.5767 6.20156C11.5767 7.47087 11.1595 8.63098 10.4731 9.57273ZM5.96434 2.21621C3.79746 2.21621 2.03435 4.00416 2.03435 6.20156C2.03435 8.41261 3.79746 10.2006 5.96434 10.1869C8.13123 10.1869 9.89434 8.39896 9.89434 6.20156C9.89434 4.00416 8.13123 2.21621 5.96434 2.21621Z",
    fill: "#444B50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c291c817.svg";
export { ForwardRef as ReactComponent };